import React from "react";
import Navbar from "../Components/Navbar";
import Footer from '../Components/Footer';
import JuniorDayCampPage1 from "../Components/JuniorDayCampPage1.js";
import JuniorCampPage2 from "../Components/JuniorCampPage2";
import JuniorCampPage3 from "../Components/JuniorCampPage3";
import '../Styles/CampsJuniors.scss';
import {Helmet} from "react-helmet";

function DayCampJuniors() {
   return (
      <div>
         <Helmet>
            <title>Junior Day Camp - Camp Connect</title>
         </Helmet>
         <div className='juniorNavbar'>
            <Navbar />
         </div>
         <JuniorDayCampPage1 />
         <JuniorCampPage2 />
         <JuniorCampPage3 />
         <Footer/>
      </div>
   )
};

export default DayCampJuniors;
